import React, { useEffect, useRef, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import Checkbox from "./../../../component/atoms/input/checkbox";
import RedBtn from "../../../component/atoms/button/redBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "./../../../component/atoms/input/mainInput";
import { useNavigate, useParams } from "react-router-dom";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import scrollToTop from "../../../util/scrollToTop";
import ChapterApi from "../../../api/chapter.api";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import FileApi from "../../../api/file.api";
import { route } from "../../../router/route";

// TODO:
// - 추후 미리보기 페이지 구현 필요 (프리뷰 페이지 별도로 만들어야 할듯)

const ShoppingProductChapterEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getChapterInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 대제목 관련 ---------- //
  const [selectedChapterTitle, setSelectedChapterTitle] = useState({
    id: "",
    title: "",
  });

  // ---------- 소제목 관련 ---------- //
  // 소제목 정보 가져오기
  const [chapterData, setChapterData] = useState({});
  const [isVideoFileActive, setIsVideoFileActive] = useState(false);

  const getChapterInfo = async () => {
    try {
      const response = (await ChapterApi.getByIdChapter(id)).data.data.content;
      setChapterData(response);

      // 대제목 정보 설정
      setSelectedChapterTitle({
        id: response?.chapterTitle?.id || 0,
        title: response?.chapterTitle?.title || "",
      });

      // 영상 파일 유무 확인
      if (response.videoServerFileName) {
        setIsVideoFileActive(true);
      } else {
        setIsVideoFileActive(false);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const editChapter = async () => {
    try {
      if (!chapterData.title) {
        toast("소제목을 입력해 주세요.");
        return;
      } else if (isVideoFileActive && chapterData.videoOriginFileName === "") {
        toast("영상 파일을 업로드해 주세요.");
        return;
      } else if (
        !chapterData.content ||
        chapterData.content === "<p><br></p>"
      ) {
        toast("상세 내용을 입력해 주세요.");
        return;
      }

      if (videoFile) {
        const response = await FileApi.fileUpload(videoFile, "admin/chapter");

        const data = {
          ...chapterData,
          videoOriginFileName: videoFile.name,
          videoServerFileName: response.data.data.serverFileName,
        };

        await ChapterApi.updateChapter(chapterData.id, data);
      } else {
        await ChapterApi.updateChapter(chapterData.id, chapterData);
      }

      toast("목차가 수정되었습니다.");
      navigate(-1);
      setVideoFile(null);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 영상 파일 관련 ---------- //
  const [videoFile, setVideoFile] = useState(null);

  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // 선택된 파일

    if (file) {
      setChapterData((prev) => ({
        ...prev,
        videoOriginFileName: file.name,
      }));

      setVideoFile(file);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // input의 value를 초기화하여 같은 파일 선택 가능하게 함
    }
  };

  const deleteVideoFile = () => {
    fileInputRef.current.value = "";
    setChapterData((prev) => ({
      ...prev,
      videoOriginFileName: "",
      videoServerFileName: "",
    }));
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // ---------- 텍스트 에디터 관련 ---------- //
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout
          style={{
            position: "relative",
          }}
        >
          <TableTitle>목차 편집</TableTitle>

          {/* 대제목 영역 */}
          <BasicContentSettingInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <BasicContentSettingInputTitle>
              대제목
            </BasicContentSettingInputTitle>
            <MainInput
              type={"text"}
              placeholder={""}
              style={{ width: "338px" }}
              value={selectedChapterTitle.title}
              disabled={true}
              onChange={(e) => {
                setSelectedChapterTitle({
                  ...selectedChapterTitle,
                  title: e.target.value,
                });
              }}
            />
          </BasicContentSettingInputWrapper>

          {/* 소제목 영역 */}
          <BasicContentSettingInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <BasicContentSettingInputTitle>
              소제목
            </BasicContentSettingInputTitle>
            <MainInput
              type={"text"}
              placeholder={"소제목을 입력해 주세요."}
              style={{ width: "572px" }}
              value={chapterData.title}
              onChange={(e) => {
                setChapterData((prev) => ({
                  ...prev,
                  title: e.target.value,
                }));
              }}
            />
          </BasicContentSettingInputWrapper>

          {/* 영상 파일 영역 */}
          <BasicContentSettingInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <BasicContentSettingInputTitle>
              영상 파일
            </BasicContentSettingInputTitle>
            {chapterData.videoOriginFileName !== "" && (
              <>
                <PretendardText
                  style={{
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: "21px",
                    color: "#999",
                    marginRight: 20,
                  }}
                >
                  {chapterData.videoOriginFileName}
                </PretendardText>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <RedBtn onClick={deleteVideoFile}>삭제</RedBtn>
                  <GrayBtn onClick={handleUploadClick}>영상 업로드</GrayBtn>
                </div>
              </>
            )}
            {chapterData.videoOriginFileName === "" && (
              <GrayBtn onClick={handleUploadClick}>영상 업로드</GrayBtn>
            )}
          </BasicContentSettingInputWrapper>
          <input
            type="file"
            accept=".wmv, .avi, .mov, .mpeg, .mp4" // 동영상 파일만 허용
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />

          {/* 미리보기 영역 */}
          <BasicContentSettingInputWrapper
            style={{
              padding: "21px 0px",
              alignItems: "flex-start",
            }}
          >
            <BasicContentSettingInputTitle>
              미리보기
            </BasicContentSettingInputTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <Checkbox
                  checked={chapterData.isPreview}
                  onChange={() => {
                    setChapterData((prev) => ({
                      ...prev,
                      isPreview: !chapterData.isPreview,
                    }));
                  }}
                />
                <PretendardText
                  style={{
                    fontWeight: 500,
                    fontSize: 15,
                    lineHeight: "21.5px",
                    color: "#aaa",
                  }}
                >
                  미리보기 시에 이 소목차를 일부 공개로 노출
                </PretendardText>
              </div>
              <PretendardText
                style={{
                  fontWeight: 500,
                  fontSize: 13,
                  lineHeight: "18.72px",
                  color: "rgba(181, 181, 181, 0.5)",
                  paddingLeft: 30,
                }}
              >
                지식상점 전자책 & 강의 상품에만 적용됩니다
              </PretendardText>
            </div>
          </BasicContentSettingInputWrapper>

          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={chapterData.content}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(contents) => {
              setChapterData((prev) => ({
                ...prev,
                content: contents,
              }));
            }}
            editorHeight={668}
            style={{
              width: "100%",
              marginTop: "24px",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn
              isTransparent={true}
              onClick={() => {
                navigate(-1);
                scrollToTop();
              }}
            >
              이전으로
            </BasicBtn>
            <BasicBtn onClick={editChapter}>수정하기</BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default ShoppingProductChapterEdit;

const BasicContentSettingInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const BasicContentSettingInputTitle = styled(PretendardText).attrs(
  (props) => {}
)`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;
